function handleTabs() {
  var tabLinks = document.querySelectorAll(".js-customer-tab");
  var tabContents = document.querySelectorAll(".js-customer-tabcontent");

  tabLinks.forEach(function(ele) {
    ele.addEventListener('click', function(evt) {
      evt.preventDefault();
      var tabName = this.getAttribute('data-tab');

      for (var i=0; i < tabContents.length; i++) {
        tabContents[i].classList.add('hidden');
      }
      for (var j=0; j < tabLinks.length; j++) {
        tabLinks[j].classList.remove('is--active');
      }

      document.querySelector('.js-customer-tabcontent[data-tab="' + tabName + '"]').classList.remove('hidden');
      document.querySelector('.js-customer-tab[data-tab="' + tabName + '"]').classList.add('is--active');
    })
  })
}

function toggleRecoverPassword() {
  var recoverLinks = document.querySelectorAll('.js-toggle-recover');

  recoverLinks.forEach(function(ele) {
    ele.addEventListener('click', function(evt) {
      evt.preventDefault();

      document.getElementById('CustomerTabWrapper').classList.toggle('is--hidden');
      document.getElementById('CustomerRecoverPassword').classList.toggle('is--hidden');
    })
  })
}

function togglePasswordField() {
  var toggleButton = document.getElementById('passwordEyeToggle');
  var toggleButtonRegister = document.getElementById('passwordEyeToggleRegister');
  var passwordField = document.getElementById('CustomerLoginPassword');
  var passwordFieldRegister = document.getElementById('CustomerRegisterPassword');

  if(!toggleButton) return;

  toggleButton.addEventListener('click', function(evt) {
    evt.preventDefault();

    const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
    passwordField.setAttribute('type', type);
    document.querySelectorAll('#passwordEyeToggle svg').forEach(function(ele){ele.classList.toggle('hidden')})
  })

  toggleButtonRegister.addEventListener('click', function(evt) {
    evt.preventDefault();

    const type = passwordFieldRegister.getAttribute('type') === 'password' ? 'text' : 'password';
    passwordFieldRegister.setAttribute('type', type);
    document.querySelectorAll('#passwordEyeToggleRegister svg').forEach(function(ele){ele.classList.toggle('hidden')})
  })

}

function toggleAddNewAddressForm() {
  var toggleButton = document.querySelectorAll(".js-toggle-newaddress");
  var addressFormWrap = document.getElementById('NewAddressForm');

  toggleButton.forEach(function(ele) {
    ele.addEventListener('click', function(evt) {
      evt.preventDefault();

      for (var i=0; i < toggleButton.length; i++) {
        toggleButton[i].classList.toggle('is--hidden');
      }

      addressFormWrap.classList.toggle('hidden');
    })
  })
}

function toggleEditAddressForm() {
  var toggleButton = document.querySelectorAll(".js-toggle-editaddress");

  toggleButton.forEach(function(ele) {
    ele.addEventListener('click', function(evt) {
      evt.preventDefault();

      var addressId = this.getAttribute('data-address');
      var editFormWrap = document.getElementById('EditAddress_' + addressId);
      editFormWrap.classList.toggle('hidden');
    })
  })
}

function generateStateSelector() {
  var countrySelector = document.getElementById('AddressNewCountry');
  var editCountryList = document.getElementById('EditAddressList');
  
  if(countrySelector) {
    new Shopify.CountryProvinceSelector('AddressNewCountry', 'AddressNewState', {hideElement: 'AddressNewStateContainer'});  
  }
  if(editCountryList) {
    var addressIds = JSON.parse(document.getElementById('EditAddressList').getAttribute('data-address-ids'));

    for(var i=0; i < addressIds.length; i++) {
      var countryId = 'AddressEditCountry-' + addressIds[i];
      var stateId = 'AddressEditState-' + addressIds[i];
      var stateContainerId = 'AddressEditStateContainer-' + addressIds[i];

      new Shopify.CountryProvinceSelector(countryId, stateId, {hideElement: stateContainerId}); 
    }
  }
}

function closeSizeGuideModal() {
  let sizeGuideModal = document.querySelector('.size-modal');
  let closeBtn = document.querySelector('.size-modal__close');

  if(closeBtn && sizeGuideModal) {
    closeBtn.addEventListener('click', function(event) {
      event.preventDefault();

      sizeGuideModal.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    })  
  }
}

function closeNotifyModal() {
  let notifyModal = document.querySelector('.js-notify-modal');

  if(!notifyModal) {
    return;
  }

  let closeBtn = notifyModal.querySelector('.js-notify-modal-close');
  let errorMessage = notifyModal.querySelector('.js-notify-modal-error');


  if(closeBtn) {
    closeBtn.addEventListener('click', function(event) {
      event.preventDefault();

      notifyModal.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');

      if(errorMessage) {
        errorMessage.classList.add('hidden');
        errorMessage.innerText = '';
      }
    })
  }
}

function openNotifyModal(errorText = '') {
  let notifyModal = document.querySelector('.js-notify-modal');

  if(!notifyModal) {
    return;
  }

  notifyModal.classList.remove('hidden');
  document.body.classList.add('overflow-hidden');

  let errorMessage = notifyModal.querySelector('.js-notify-modal-error');

  if (errorMessage && errorText) {
    errorMessage.innerText = errorText;
    errorMessage.classList.remove('hidden');
  }
}

document.addEventListener('NotifyModalBackInStock:Open', function (event){
  let errorText = '';
  if(event.detail && event.detail.errorText) {
    errorText = event.detail.errorText;
  }

  openNotifyModal(errorText);
});


document.addEventListener("DOMContentLoaded", function() {
  handleTabs();
  toggleRecoverPassword();
  togglePasswordField();
  toggleAddNewAddressForm();
  toggleEditAddressForm();
  generateStateSelector();
  closeSizeGuideModal();
  closeNotifyModal();


  if (window.location.hash == '#recover') { 
    document.getElementById('CustomerTabWrapper').classList.add('is--hidden');
    document.getElementById('CustomerRecoverPassword').classList.remove('is--hidden');
  }
})

 

